// extracted by mini-css-extract-plugin
export var bookDiscount = "bookDiscoint-module--bookDiscount--M86B5";
export var wrapHeader = "bookDiscoint-module--wrapHeader--DZpdT";
export var form = "bookDiscoint-module--form--Dugoj";
export var inputGroup = "bookDiscoint-module--inputGroup--zV-Fd";
export var input = "bookDiscoint-module--input--tY+QW";
export var button = "bookDiscoint-module--button--JQMgf";